import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoArrecadacaoEnum } from "features/arrecadacoes/enums";

const { Option } = Select;

export interface SelectTipoArrecadacao<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
}

function SelectRecorrencia({
  value,
  isInvalid,
  onChange,
  ...rest
}: SelectTipoArrecadacao) {
  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder="Tipo de recorrência"
        style={{ width: "100%" }}
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        <Option value={TipoArrecadacaoEnum.ValorIgualTodasUnidades} key="i">
          Igual para todas as unidades do condomínio
        </Option>
        <Option value={TipoArrecadacaoEnum.ValorMetrosUnidade} key="m">
          Para cada M² da unidade
        </Option>
      </SelectBaseAntd>
    </>
  );
}

export default SelectRecorrencia;
